/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2023 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { publicApiNames } from "publicApis/constants";
import { apiFactory } from "api/external/ApiFactory";
import { isFunction } from "utils/APIUtils";
import { featureLifecycleHookController } from "./controller/featureLifecycleHookController";
import { featureLifecyleHooks } from "constants/enums";

const getNavigationBarApis = stores => {
  function beforeNavigationBarToolActivated(callback, opts = {}) {
    if (isFunction(callback)) {
      if (opts.isSave) {
        featureLifecycleHookController.on(featureLifecyleHooks.SAVE_BEFORE_NAVIGATION_BAR_TOOL_ACTIVATED, callback);
      } else {
        featureLifecycleHookController.on(featureLifecyleHooks.BEFORE_NAVIGATION_BAR_TOOL_ACTIVATED, callback);
      }
    }
  }

  return {
    beforeNavigationBarToolActivated
  };
};

export const registerNavigationBarApis = stores => {
  apiFactory.registerApi(publicApiNames.NAVIGATIONBAR, clientName => getNavigationBarApis(stores), true);
};
